import React from 'react';
import {
  FileEarmarkPdfFill,
  FileEarmarkSpreadsheetFill,
  FileEarmarkTextFill,
} from 'react-bootstrap-icons';
import S3MediaLink from '../Generic/S3MediaLink';
import {
  normalizeOrderFiles,
  orderFileMediaKind,
  orderFileRowIsPendingUpload,
} from '../../utils/orderFiles';

/**
 * Icon for order file table links.
 *
 * @param {Object} file
 * @param {'po'|'receipt'} category
 */
function OrderFileLinkIcon({ file, category }) {
  const kind = orderFileMediaKind(file, { category });
  if (kind === 'pdf') {
    return <FileEarmarkPdfFill size="1.5rem" />;
  }
  if (kind === 'csv' || kind === 'spreadsheet') {
    return <FileEarmarkSpreadsheetFill size="1.5rem" />;
  }
  return <FileEarmarkTextFill size="1.5rem" />;
}

/**
 * Table cell: links for one order file category.
 *
 * @param {{ order: Object, category: 'po'|'receipt' }} props
 */
const OrderFileLinksCell = ({ order, category }) => {
  const { po_files, receipt_files } = normalizeOrderFiles(order);
  const files = category === 'po' ? po_files : receipt_files;

  if (!files.length) {
    return <span className="text-muted small">—</span>;
  }

  return (
    <div className="d-flex flex-row flex-wrap justify-content-center gap-1">
      {files.map((file, idx) => {
        const url = file.image_url;
        if (!url || orderFileRowIsPendingUpload(file)) {
          return (
            <span key={file.id ?? idx} className="text-muted small" title="Uploading">
              …
            </span>
          );
        }
        return (
          <S3MediaLink
            key={file.id ?? idx}
            url={url}
            orderImageId={file.id}
            title="Open file"
          >
            <OrderFileLinkIcon file={file} category={category} />
          </S3MediaLink>
        );
      })}
    </div>
  );
};

export default OrderFileLinksCell;
